import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const StyledList = superstyled({
  name: 'StyledList',
  tag: List,
  propsAdded: {
    role: 'list',
  },
  styles: ({ theme }) => ({
    border: `0.0625rem solid ${theme.palette.divider}`,
    borderRadius: '0.75rem',
    padding: '1rem',
    background: theme.palette.background.grey.light,
    fontSize: '0.875rem',
  }),
});

export const StyledListItem = superstyled({
  name: 'StyledListItem',
  tag: ListItem,
  propsAdded: {
    role: 'listitem',
    tabIndex: 0,
  },
  styles: () => ({
    padding: '1rem 0 1rem 0',
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
    },
    '&:first-of-type': {
      paddingTop: 0,
    },
  }),
});

export const StyledSuggestionContainer = superstyled({
  name: 'StyledSuggestionContainer',
  tag: Stack,
  styles: () => ({
    fontSize: '0.875rem',
  }),
});

export const StyledSuggestionTitle = superstyled({
  name: 'StyledSuggestionTitle',
  tag: Text,
  styles: {
    fontWeight: 600,
    textTransform: 'capitalize',
  },
});

export const StyledSuggestionDescription = superstyled({
  name: 'StyledSuggestionDescription',
  tag: Text,
  styles: {
    fontWeight: 400,
    lineHeight: '1.25rem',
  },
});

export const StyledSuggestionBody = superstyled({
  name: 'StyledSuggestionBody',
  tag: Text,
  styles: {
    fontWeight: 400,
    lineHeight: '1.25rem',
    whiteSpace: 'pre-line',
  },
});
